interface Props {
  label: string;
  onPress: () => void;
}

export const RectangleCard = ({ label, onPress }: Props) => {
  return (
    <div className="flex-center-center-column-nowrap rectangleCard" onClick={onPress}>
      <div className="boldText5">{label}</div>
    </div>
  );
};
